import { render, staticRenderFns } from "./AccountHolderUserSystemId.vue?vue&type=template&id=6e95a1d0"
import script from "./AccountHolderUserSystemId.vue?vue&type=script&lang=ts"
export * from "./AccountHolderUserSystemId.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports